import { Wizard as PixieWizard } from "@pacificoseguros/pixie/react/wizard";
import React, { useMemo } from "react";
import { Row } from "../../../components/layout/flex-layout";
import { SpacingBox } from "../../../components/layout/spacing-box";
import {
    ROUTE_APP_CARD_PAYMENT_CONFIRMATION,
    ROUTE_APP_EMPTY,
    ROUTE_APP_SUMMARY,
} from "../../../constants/routes/app";
import { useChannel } from "../../../libs/channels/hooks/use-channel";

export const Wizard = () => {
    const { normalizedPathname } = useChannel();
    const isVisibleWizard = useMemo(
        () =>
            normalizedPathname !== ROUTE_APP_EMPTY &&
            normalizedPathname !== ROUTE_APP_CARD_PAYMENT_CONFIRMATION,
        [normalizedPathname]
    );
    const currentStep = useMemo(() => {
        switch (normalizedPathname) {
            case ROUTE_APP_SUMMARY:
                return 2;
            default:
                return 1;
        }
    }, [normalizedPathname]);
    return (
        isVisibleWizard && (
            <SpacingBox my={12}>
                <Row justify="center" data-testid="wizard">
                    <PixieWizard
                        className="quotation__steps__wizard"
                        length={2}
                        current={currentStep}
                    />
                </Row>
            </SpacingBox>
        )
    );
};
